import type { ReactNode } from 'react'
import { cn } from '@/shared/lib/utils'
import { Tag } from './Tag'

/**
 * Carte e-billet mobile - DESIGN §8 (RV-25). **Présentationnel** : affiche l'image QR
 * **rendue côté serveur** (`qrImageSrc`, signée + expirante) - ne génère jamais le QR côté
 * client (sécurité). Grand QR centré sur fond blanc (lisibilité scanner), réf + expiration.
 * Libellés fournis i18n par l'appelant.
 */
export function QrTicket({
  qrImageSrc,
  alt,
  instruction,
  reference,
  expiresLabel,
  className,
}: {
  /** URL/data-URI du QR **généré côté serveur**. */
  qrImageSrc: string
  alt: string
  instruction?: ReactNode
  /** Référence du billet (mono). */
  reference?: ReactNode
  expiresLabel?: ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        'mx-auto flex max-w-xs flex-col items-center gap-4 rounded-lg border border-[var(--v2-line)] bg-[var(--v2-surface)] p-5 text-center shadow-sm',
        className,
      )}
    >
      {instruction ? <p className="text-sm text-[var(--v2-ink-2)]">{instruction}</p> : null}
      <img
        src={qrImageSrc}
        alt={alt}
        width={240}
        height={240}
        // Fond blanc fixe + data-theme-keep : jamais atténué en dark (scannabilité).
        data-theme-keep
        className="size-60 rounded-md border border-[var(--v2-line)] bg-white p-3"
      />
      {reference ? <Tag>{reference}</Tag> : null}
      {expiresLabel ? <p className="text-xs text-[var(--v2-ink-3)]">{expiresLabel}</p> : null}
    </div>
  )
}
